import echarts from 'echarts'
/* {
  ref:传入要渲染得元素
  xdata:x轴得数据
  ydata:y轴得数据
}*/
function drawEchart (
  ref,
  xdata,
  ydata,
  title,
  yname,
  xname
) {

  const CubeLeft = echarts.graphic.extendShape({
    shape: {
      x: 0,
      y: 0,
    },
    buildPath: function (ctx, shape) {
      const xAxisPoint = shape.xAxisPoint;
      const c0 = [shape.x, shape.y];
      const c1 = [shape.x - 9, shape.y - 9];
      const c2 = [xAxisPoint[0] - 9, xAxisPoint[1] - 9];
      const c3 = [xAxisPoint[0], xAxisPoint[1]];
      ctx
        .moveTo(c0[0], c0[1])
        .lineTo(c1[0], c1[1])
        .lineTo(c2[0], c2[1])
        .lineTo(c3[0], c3[1])
        .closePath();
    },
  });
  const CubeRight = (echarts.graphic.extendShape)({
    shape: {
      x: 0,
      y: 0,
    },
    buildPath: function (ctx, shape) {
      const xAxisPoint = shape.xAxisPoint;
      const c1 = [shape.x, shape.y];
      const c2 = [xAxisPoint[0], xAxisPoint[1]];
      const c3 = [xAxisPoint[0] + 18, xAxisPoint[1] - 9];
      const c4 = [shape.x + 18, shape.y - 9];
      ctx
        .moveTo(c1[0], c1[1])
        .lineTo(c2[0], c2[1])
        .lineTo(c3[0], c3[1])
        .lineTo(c4[0], c4[1])
        .closePath();
    },
  });
  const CubeTop = (echarts.graphic.extendShape)({
    shape: {
      x: 0,
      y: 0,
    },
    buildPath: function (ctx, shape) {
      const c1 = [shape.x, shape.y];
      const c2 = [shape.x + 18, shape.y - 9];
      const c3 = [shape.x + 9, shape.y - 18];
      const c4 = [shape.x - 9, shape.y - 9];
      ctx
        .moveTo(c1[0], c1[1])
        .lineTo(c2[0], c2[1])
        .lineTo(c3[0], c3[1])
        .lineTo(c4[0], c4[1])
        .closePath();
    },
  });
  // (this.$echarts as any)
  echarts.graphic.registerShape("CubeLeft", CubeLeft);
  echarts.graphic.registerShape("CubeRight", CubeRight);
  echarts.graphic.registerShape("CubeTop", CubeTop);
  let mychart = echarts.init(ref);
  mychart.setOption({
    backgroundColor: "#ffffff",
    tooltip: {
      trigger: "axis",
      formatter: function (a) {
        return '<div><p>' + a[0].name + '：' + a[1].value + '</p></div>'
      },
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: "none", // 默认为直线，可选为：'line' | 'shadow'
      },
    },
    // 设置滚动条 
    dataZoom: [{
      "show": true,
      "height": 20,
      "xAxisIndex": [
        0
      ],
      // bottom: '8%',
      "start": 20,
      "end": 80,
      handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
      handleSize: '110%',
      handleStyle: {
        color: "#d3dee5",

      },
      textStyle: {
        color: "#000"
      },
      borderColor: "#90979c"
    }, {
      type: 'inside',
      start: 0,
      end: 100
    }],
    title: {
      text: title,
      x: 'center',
      textStyle: {
        color: "#333333",
        fontSize: 16,
      },

    },
    grid: {
      left: 20,
      right: 70,
      // bottom: 80,
      top: 70,
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: xdata,
      name: xname,
      axisLine: {
        show: true,
        symbolSize: (100, 8),
        symbol: ['none', 'arrow'],
        lineStyle: {
          color: "#969A9F",
        },
      },

      offset: 20,
      axisTick: {
        show: false,
        length: 9,
        alignWithLabel: true,
        lineStyle: {
          color: "#969A9F",
        },
      },
      axisLabel: {
        fontSize: 10,
      },
    },
    yAxis: {
      type: "value",
      name: yname,
      axisLine: {
        show: true,
        symbolSize: (100, 8),
        symbol: ['none', 'arrow'],
        lineStyle: {
          color: "#969A9F",
        },
      },
      splitLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        fontSize: 16,
      },
      boundaryGap: ["0%", "20%"],
    },
    series: [
      {
        type: "custom",
        renderItem: function (params, api) {
          const location = api.coord([api.value(0), api.value(1)]);
          return {
            type: "group",
            children: [
              {
                type: "CubeLeft",
                shape: {
                  api,
                  xValue: api.value(0),
                  yValue: api.value(1),
                  x: location[0],
                  y: location[1],
                  xAxisPoint: api.coord([api.value(0), 0]),
                },
                style: {
                  fill: "rgba(47,102,192,.27)",
                },
              },
              {
                type: "CubeRight",
                shape: {
                  api,
                  xValue: api.value(0),
                  yValue: api.value(1),
                  x: location[0],
                  y: location[1],
                  xAxisPoint: api.coord([api.value(0), 0]),
                },
                style: {
                  fill: "rgba(59,128,226,.27)",
                },
              },
              {
                type: "CubeTop",
                shape: {
                  api,
                  xValue: api.value(0),
                  yValue: api.value(1),
                  x: location[0],
                  y: location[1],
                  xAxisPoint: api.coord([api.value(0), 0]),
                },
                style: {
                  fill: "rgba(59,128,226,.27)",
                },
              },
            ],
          };
        },
        data: ydata,
      },
      {
        type: "custom",
        renderItem: (params, api) => {
          const location = api.coord([api.value(0), api.value(1)]);
          return {
            type: "group",
            children: [
              {
                type: "CubeLeft",
                shape: {
                  api,
                  xValue: api.value(0),
                  yValue: api.value(1),
                  x: location[0],
                  y: location[1],
                  xAxisPoint: api.coord([api.value(0), 0]),
                },
                style: {
                  fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "rgb(60,160,255)",
                    },
                    {
                      offset: 1,
                      color: "rgb(48,65,86)",
                    },
                  ]),
                },
              },
              {
                type: "CubeRight",
                shape: {
                  api,
                  xValue: api.value(0),
                  yValue: api.value(1),
                  x: location[0],
                  y: location[1],
                  xAxisPoint: api.coord([api.value(0), 0]),
                },
                style: {
                  fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#1890FF",
                    },
                    {
                      offset: 1,
                      color: "rgb(30,44,65)",
                    },
                  ]),
                },
              },
              {
                type: "CubeTop",
                shape: {
                  api,
                  xValue: api.value(0),
                  yValue: api.value(1),
                  x: location[0],
                  y: location[1],
                  xAxisPoint: api.coord([api.value(0), 0]),
                },
                style: {
                  fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#1890FF",
                    },
                    {
                      offset: 1,
                      color: "rgb(30,44,65)",
                    },
                  ]),
                },
              },
            ],
          };
        },
        data: ydata,
      },
      {
        type: "bar",
        label: {
          normal: {
            show: true,
            position: "top",
            formatter: (e) => {
              switch (e.name)
              {
                case "10kV线路":
                  return ydata[0];
                case "公用配变":
                  return ydata[1];
                case "35kV主变":
                  return ydata[2];
                case "水":
              }
            },
            fontSize: 16,
            color: "#fff",
            offset: [4, -25],
          },
        },
        itemStyle: {
          color: "transparent",
        },
        // data: ydata,
      },
    ],
  });
}
export {
  drawEchart
}